import { ISagaCb } from '@typings/requestPayloads'
import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ICreateMeetingRequestPayload } from './create'

export interface ISuggestMeetingRequestByTokenPayload extends ISagaCb, ICreateMeetingRequestPayload {
    token: string
}

export interface ISuggestMeetingRequestByTokenState {
    status: string
    data: any
    errors: any
}

const initialState: ISuggestMeetingRequestByTokenState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const suggestMeetingRequestByToken = createSlice({
    name: 'meeting-requests/suggest',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<ISuggestMeetingRequestByTokenPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const suggestMeetingRequestByTokenActions = suggestMeetingRequestByToken.actions
export default suggestMeetingRequestByToken.reducer
